export default "__VITE_ASSET__CZ2mAj$o__"